import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthGuard } from '../_guards';
import { tap, takeUntil, map } from 'rxjs/operators';
import { Router, ActivationEnd } from '@angular/router';
import { HttpCancelService } from './http-cancel-service.service';
import { ToasterService } from '../_services/toaster.service';
declare var jquery: any;
declare var $: any;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  // tslint:disable-next-line: max-line-length
  constructor(private authService: AuthGuard, private router: Router, private toastr: ToasterService, private httpCancelService: HttpCancelService) {
 router.events.subscribe((event) => {
   // An event triggered at the end of the activation part of the Resolve phase of routing.
   if (event instanceof ActivationEnd) {
  // Cancel pending calls
  this.httpCancelService.cancelPendingRequests();
  if (event.snapshot) {
 if (event.snapshot.routeConfig && event.snapshot.routeConfig.path) {
   let path = '';
   path = path === '' ? event.snapshot.routeConfig.path : [event.snapshot.routeConfig.path, path].join('/');
   if (!path.includes('login')) {
  //  this.toastr.clearToast();
   }
 }
  }
   }
 });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
 if (this.authService.isLoggedIn()) {
   const authToken = this.authService.getAuthorizationToken();
   req = req.clone({
  setHeaders: { Authorization: 'Bearer ' + authToken }
   });
 }

 return next.handle(req).pipe(
   map((event: HttpEvent<any>) => {
  return event;
   }),
   // For cancelling previous requests

   takeUntil(this.httpCancelService.onCancelPendingRequests()),
   // If an error occured in api request or 401
   tap(() => { },
  (err: any) => {
 $('body').removeClass('loading').loader('hide');
 if (err instanceof HttpErrorResponse) {
   if (err.status === 500) {
  // If any error occured at server side
  this.toastr.Error('Server Error', 'Error occured while performing your request', false);
   }
   if (err.status === 400) {
  // tslint:disable-next-line: max-line-length
  this.toastr.Error(err.error.responseMessage ? err.error.responseMessage : 'Error occured', 'Error occured while performing your request', false);
   }
   if (err.status !== 401) {
  // Incase of request get successfully executed
  return;
   }
   // If session expired
   this.router.navigate(['login']);
   this.toastr.Error('Please login again, your session got expired.', '', true);
 }
  }
   ));
  }
}
